import {animate, animation, group, state, style, transition, trigger} from '@angular/animations';

export const enterAnimation = animation([
  style({ transform: `translateX(200%)`}),
  animate('220ms', style({transform: `translateX(0)`}))
])

export const leaveAnimation = animation([
  style({ transform: `translateX(0)`}),
  animate('220ms', style({transform: `translateX(200%)`}))
])

export const enterVerticalAnimation = animation([
  style({ transform: `translateY(-100%)`, opacity: 0}),
  animate('220ms', style({transform: `translateY(0)`, opacity: 1}))
])

export const leaveVerticalAnimation = animation([
  style({ transform: `translateY(0)`, opacity: 1}),
  animate('220ms', style({transform: `translateY(-100%)`, opacity: 0}))
])
